import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import jwtDecode from 'jwt-decode';
import { useLocation, useNavigate, useParams } from 'react-router';
import { userSelector } from '../../store/shared/userSlice';
import { useLazyGetAccountListQuery } from '../../../Admin/AccountSelect/apiSlice';
import { useSignalRStartAction } from '../../hooks/useSignalRConnector';
import useReportScreenLoad from '../../hooks/useReportScreenLoad';
import { accountSelector } from '../../store/shared/accountSlice';
import { JwtDecodedUser } from '../../models/UserModels';

export default function AutoSwitcher({ children }: any) {
  const { value: user, isLoaded } = useSelector(userSelector);
  const navigate = useNavigate();
  const accessToken = user ? user.access_token : '';
  const { currentAccountId } = useSelector(accountSelector);
  const { accountId } = useParams<{ accountId: string }>();
  const acctId = currentAccountId || accountId;
  const location = useLocation();
  const authUser: JwtDecodedUser = accessToken ? jwtDecode(accessToken) : null;

  const isHubWithCredentials =
    location.pathname.startsWith('/hub/') &&
    authUser?.b2b_aid &&
    authUser?.b2b_auid &&
    acctId &&
    authUser?.b2b_aid.toLocaleUpperCase() === acctId.toLocaleUpperCase();

  const isAminWithCredentials =
    location.pathname.startsWith('/admin/') &&
    authUser?.rbac_2fa_raids &&
    acctId;

  const isAdminOrHubWithCredentials =
    isHubWithCredentials || isAminWithCredentials;

  const [getAccountList] = useLazyGetAccountListQuery();
  useSignalRStartAction(!isAdminOrHubWithCredentials);

  useEffect(() => {
    if (location.pathname === '/') {
      getAccountList({
        page: 1,
        pageSize: 1,
      })
        .unwrap()
        .then((accountList) => {
          if (
            !accountList?.accounts ||
            accountList?.accounts?.totalItemCount <= 0
          ) {
            navigate('/hub');
          } else {
            navigate('/admin');
          }
        });
    }
  }, [isLoaded]);
  useReportScreenLoad(!isAdminOrHubWithCredentials);

  return <>{children}</>; // eslint-disable-line react/jsx-no-useless-fragment
}
